import { render, staticRenderFns } from "./SettingServiceOrari.vue?vue&type=template&id=66ca0d0d&scoped=true&"
import script from "./SettingServiceOrari.vue?vue&type=script&lang=js&"
export * from "./SettingServiceOrari.vue?vue&type=script&lang=js&"
import style0 from "./SettingServiceOrari.vue?vue&type=style&index=0&id=66ca0d0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca0d0d",
  null
  
)

export default component.exports